import React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import CustomButton from '../customButton/ui/main/CustomButton';
import useStateControls from '../../../hooks/useStateControls';

export default function Back({ className, children, button, toPrevState = true, onClick, extraComponent }) {
  const { setPrevState } = useStateControls();

  const onClickFunction = () => {
    const necessaryCallback = typeof onClick === 'function' ? onClick : toPrevState && setPrevState;

    necessaryCallback?.();
  };

  return (
    <div className={classNames('back', className)}>
      <CustomButton
        icon={'buttons/back'}
        onClick={onClickFunction}
        className={'back__button button_back button_icon button_transparent'}
        disposable={true}
        {...button}
      >
        {children}
      </CustomButton>
      {extraComponent && extraComponent}
    </div>
  );
}

Back.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
